export default {
  record: [
    {
      id: 'bibliograficos',
      label: 'tabs#record_bibliograficos'
    },
    {
      id: 'fecha',
      label: 'tabs#record_fecha'
    },
    {
      id: 'personajes',
      label: 'tabs#record_personajes'
    },
    {
      id: 'genero',
      label: 'tabs#record_genero'
    },
  ]
};
